<template lang="pug">
div
  v-form(ref="form")
    v-row(no-gutters)
      v-col(cols="12" sm="6")
        div.text-md.font-medium.basic700--text {{ $t('company_name') }}
        v-text-field.text-md.font-normal.mt-2.round-xl(v-model="companyName" :placeholder="$t('company_name')" outlined :rules="rules.not_empty" hide-details="auto" :maxlength="200")

        div.text-md.font-medium.basic700--text.mt-8 {{ $t('company_logo') }}
        div.d-flex.align-center.mt-2
          v-card(v-if="resizeImageFileUrl" flat)
            div(align="center")
              v-img(:src="resizeImageFileUrl" contain max-height="64" max-width="64")
                template(v-slot:placeholder)
                  v-row(class="fill-height ma-0" align="center" justify="center")
                    v-progress-circular(indeterminate color="grey")
          v-avatar(v-else size="64" color="neutral300")
            span.text-md.font-semibold.neutral500--text {{ getInitial(company.name) }}

          div.file-change-layout.ml-4
            v-btn.button-sm(color="basic700" outlined depressed) {{ $t('update') }}
            input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important")

  div.d-flex.mt-5
    v-spacer
    v-btn.button-md(color="neutral700" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'GeneralCompanyInfo',
  data () {
    return {
      isLoading: false,
      resizeImageFileUrl: '',
      resizeImageFile: null,
      companyName: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  mounted () {
    if (this.company) {
      this.companyName = this.company.name
      this.resizeImageFileUrl = this.company.logo?.file ?? ''
    }
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = new FormData()
      params.set('name', this.companyName)
      if (this.resizeImageFile) {
        params.append('logo', this.resizeImageFile)
      }
      this.$axios.patch(`/companies/${this.company.id}`, params)
        .then(resp => {
          this.updateCompany(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getInitial (value) {
      let name = value
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials
    }
  },
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>